import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export interface BrandMarkProps {
  size?: number | string;
  onDarkSurface?: boolean;
}

/** The winking shopkeeper, shared by the app shell and public pages. */
const BrandMark: React.FC<BrandMarkProps> = ({ size = 40, onDarkSurface }) => {
  const theme = useTheme();
  const inverse = onDarkSurface ?? theme.palette.mode === 'dark';
  const leftPage = inverse ? '#EFF2E9' : '#2E6854';
  const rightPage = inverse ? '#E5EBE1' : '#245444';
  const binding = inverse ? '#748D7E' : '#9DB9A8';

  return (
    <Box
      component="svg"
      viewBox="0 0 200 200"
      aria-hidden="true"
      focusable="false"
      sx={{ display: 'block', width: size, height: size, flexShrink: 0, overflow: 'visible' }}
    >
      <path d="M18 83C35 58 65 51 96 66Q100 68 100 75V171C73 153 42 153 18 171Z" fill={leftPage} />
      <path d="M100 75Q100 68 104 66C135 51 165 58 182 83V171C158 153 127 153 100 171Z" fill={rightPage} />
      <path d="M87 81L100 91L113 81" fill="none" stroke="#D8AD66" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M100 98V164" fill="none" stroke={binding} strokeOpacity=".9" strokeWidth="3" strokeLinecap="round" />
      <circle cx="100" cy="45" r="31" fill="#D8AD66" />
      <circle cx="88" cy="43" r="3.8" fill="#183B30" />
      <path d="M106 43Q111 39 116 43" fill="none" stroke="#183B30" strokeWidth="3.2" strokeLinecap="round" />
      <path d="M90 57Q100 65 110 56" fill="none" stroke="#183B30" strokeWidth="3" strokeLinecap="round" />
    </Box>
  );
};

export default BrandMark;
